<template>
  <v-card class="elevation-1">
    <v-card-title>
        <h3 style="margin-left:25px">แพคเกจ</h3>
        <v-spacer></v-spacer>
        <v-select
          v-model="search"
          :items="dataBranch"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          clearable
        ></v-select>
      </v-card-title>
    <v-data-table
      v-if="lastestCollect"
      :headers="lastestCollectHeader"
      :items="lastestCollect"
      :search="search"
      :items-per-page="5"
      class="elevation-1"
    >
      <!-- <template v-slot:[`item.LAST_DATE`]="{ item }">
        {{ thaiFormattedDate(item.LAST_DATE) }}
      </template>
      <template v-slot:[`item.packagePrice`]="{ item }">
        {{ formatNumber(item.packagePrice.toFixed(2)) }}
      </template>
      <template v-slot:[`item.avgPrice`]="{ item }">
        {{ formatNumber(item.avgPrice.toFixed(2)) }}
      </template>
      <template v-slot:[`item.point`]="{ item }">
        {{ formatNumber(item.point) }}
      </template> -->
    </v-data-table>
  </v-card>
</template>
<script>
import axios from 'axios' // api
// import moment from 'moment' // แปลง date
export default {
  components: {},
  data () {
    return {
      session: this.$session.getAll(),
      lastestCollect: null,
      lastestCollectHeader: [
        { text: 'แพคเกจ', value: 'packageName', align: 'left' },
        { text: 'ราคาของแพคเกจ', value: 'packagePrice', align: 'right' },
        { text: 'จำนวนที่มาใช้แพคเกจ', value: 'amountUsed', align: 'center' },
        { text: 'ราคาต่อครั้งของแพคเกจ', value: 'avgPrice', align: 'right' },
        { text: 'รายได้ของการใช้แพคเกจ', value: 'total', align: 'right' }
      ],
      dataBranch: [],
      search: ''
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      //   this.strDate = this.momenDate_1(dateRange.startDate)
      //   this.endDate = this.momenDate_1(dateRange.endDate)
      this.lastestCollect = []
      await axios
        .get(
          this.DNS_IP + '/PackageCal/get?shopId=' + this.session.data.shopId
          // +
          // '&last_date_str=' +
          // this.strDate +
          // '&last_date_end=' +
          // this.endDate
        )
        .then(async response => {
          let rs = response.data
          if (rs.status === false) {
            this.lastestCollect = []
          } else {
            // let data = []
            // rs.map(el => data.push(el.amountUsed * el.avgPrice))
            // console.log('data', data)
            this.lastestCollect = rs
            this.lastestCollect.map((el) => {
              el.total = el.amountUsed * el.avgPrice
            //   console.log('el', k)
            })
            // this.lastestCollect.forEach((v, k) => {
            //   console.log('this.lastestCollect[k]', v)
            //   v.total2 = v.amountUsed * v.avgPrice
            // })
            // console.log('rs33333', this.lastestCollect)
          }
        })
    }
  }
}
</script>
<style scope>
.chart-container {
  width: 100%;
  max-height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/Chart/Package.vue